<div class="wrapper-customers email-templates-page">
    <!-- Top Nav (Preserved) -->
    <div class="section-title">
        <div class="row">
            <div class="col">
                <div class="d-flex align-items-center">
                    <div class="title">{{ "Automated Emails" | translate }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-main email-container">
        
        <!-- Intro Hero Section -->
        <div class="email-hero-card mb-4" *ngIf="!loading">
            <div class="hero-content">
                <div class="hero-text">
                    <div class="hero-badge">
                        <i class="fi-rr-envelope mr-1"></i> {{ "System Notifications" | translate }}
                    </div>
                    <h5 class="hero-title">{{ "System Email Directory" | translate }}</h5>
                    <p class="hero-subtitle">
                        {{ "Explore all automated email notifications sent by the system to customers and store administrators for order updates, account notices, and transaction alerts." | translate }}
                    </p>
                </div>
                <div class="hero-stats">
                    <div class="stat-pill" (click)="setTab('all')" [class.active]="activeTab === 'all'">
                        <span class="stat-num">{{ templates.length }}</span>
                        <span class="stat-label">{{ "Total Templates" | translate }}</span>
                    </div>
                    <div class="stat-pill customer-pill" (click)="setTab('customer')" [class.active]="activeTab === 'customer'">
                        <span class="stat-num">{{ customerTemplates.length }}</span>
                        <span class="stat-label">{{ "Customer Emails" | translate }}</span>
                    </div>
                    <div class="stat-pill admin-pill" (click)="setTab('admin')" [class.active]="activeTab === 'admin' || activeTab === 'dealer'">
                        <span class="stat-num">{{ dealerTemplates.length }}</span>
                        <span class="stat-label">{{ "Admin Emails" | translate }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Filter & Search Controls -->
        <div class="controls-bar mb-4" *ngIf="!loading && templates.length > 0">
            <div class="nav-tabs-wrapper">
                <button type="button" class="tab-btn" [class.active]="activeTab === 'all'" (click)="setTab('all')">
                    <i class="fi-rr-apps mr-1"></i> {{ "All Emails" | translate }}
                    <span class="count-badge">{{ templates.length }}</span>
                </button>
                <button type="button" class="tab-btn customer-tab" [class.active]="activeTab === 'customer'" (click)="setTab('customer')">
                    <i class="fi-rr-user mr-1"></i> {{ "Customer" | translate }}
                    <span class="count-badge">{{ customerTemplates.length }}</span>
                </button>
                <button type="button" class="tab-btn admin-tab" [class.active]="activeTab === 'admin' || activeTab === 'dealer'" (click)="setTab('admin')">
                    <i class="fi-rr-shield-check mr-1"></i> {{ "Admin" | translate }}
                    <span class="count-badge">{{ dealerTemplates.length }}</span>
                </button>
            </div>

            <div class="search-box">
                <i class="fi-rr-search search-icon"></i>
                <input type="text" 
                       class="form-control search-input" 
                       [placeholder]="'Search email templates...' | translate" 
                       [(ngModel)]="searchQuery">
                <button *ngIf="searchQuery" type="button" class="clear-btn" (click)="searchQuery = ''">
                    <i class="fi-rr-cross-small"></i>
                </button>
            </div>
        </div>

        <!-- Loading State -->
        <div class="state-card loading-card" *ngIf="loading">
            <div class="card-body text-center py-5">
                <mat-spinner class="mx-auto my-3" [diameter]="50"></mat-spinner>
                <p class="text-muted mt-2 font-weight-medium">{{ "Loading email templates..." | translate }}</p>
            </div>
        </div>

        <!-- Empty State (No Templates at all) -->
        <div class="state-card empty-card" *ngIf="templates.length === 0 && !loading">
            <div class="card-body text-center py-5">
                <div class="empty-icon mb-3">
                    <i class="fi-rr-envelope-open"></i>
                </div>
                <h5 class="font-weight-bold mb-2">{{ "No Email Templates Found" | translate }}</h5>
                <p class="text-muted max-w-400 mx-auto">{{ "There are currently no automated email templates configured in the system." | translate }}</p>
            </div>
        </div>

        <!-- No Search Results State -->
        <div class="state-card empty-card" *ngIf="templates.length > 0 && !loading && totalFilteredCount === 0">
            <div class="card-body text-center py-5">
                <div class="empty-icon mb-3">
                    <i class="fi-rr-search"></i>
                </div>
                <h5 class="font-weight-bold mb-2">{{ "No Matching Emails" | translate }}</h5>
                <p class="text-muted max-w-400 mx-auto">{{ "No email templates matched your search term '" + searchQuery + "'. Try resetting your search." | translate }}</p>
                <button type="button" class="btn btn-outline-primary rounded-pill btn-sm mt-3 px-4" (click)="searchQuery = ''; activeTab = 'all'">
                    {{ "Reset Filters" | translate }}
                </button>
            </div>
        </div>

        <!-- Customer Templates Section -->
        <div class="template-section mb-5" *ngIf="!loading && (activeTab === 'all' || activeTab === 'customer') && filteredCustomerTemplates.length > 0">
            <div class="section-header d-flex align-items-center justify-content-between mb-3">
                <div class="d-flex align-items-center gap-2">
                    <div class="section-icon-badge customer-badge">
                        <i class="fi-rr-user"></i>
                    </div>
                    <div>
                        <h5 class="section-heading mb-0">{{ "Customer Emails" | translate }}</h5>
                        <p class="section-subtext mb-0">{{ "Automated notifications sent directly to store customers" | translate }}</p>
                    </div>
                </div>
                <span class="badge badge-light-primary rounded-pill px-3 py-2 font-weight-medium">
                    {{ "{0} Templates" | translate: [filteredCustomerTemplates.length] }}
                </span>
            </div>

            <div class="email-grid">
                <div class="email-card" *ngFor="let data of filteredCustomerTemplates">
                    <div class="card-inner">
                        <!-- Top Tag Bar -->
                        <div class="card-header-bar">
                            <span class="recipient-tag tag-customer">
                                <i class="fi-rr-user mr-1"></i> {{ "Customer" | translate }}
                            </span>
                            <span class="template-id-tag" *ngIf="data.id || data.template_id">
                                #{{ data.id || data.template_id }}
                            </span>
                        </div>

                        <!-- Card Body -->
                        <div class="card-main">
                            <h6 class="email-title" [title]="data.display_name">{{ data.display_name }}</h6>
                            
                            <!-- Inline Description -->
                            <p class="email-description" [title]="data.description">
                                {{ data.description || ('Automated notification email sent to customer.' | translate) }}
                            </p>

                            <!-- Image Frame -->
                            <div class="image-frame" (click)="openModal(content)" (click)="preview(data)">
                                <img [src]="data.image"
                                     onerror="this.onerror=null;this.src='https://cdn.estore5s.com/asset/email-default.png';"
                                     [alt]="data.display_name"
                                     class="preview-img">
                                <div class="image-overlay">
                                    <span class="preview-btn">
                                        <i class="fi-rr-eye mr-1"></i> {{ "Quick View" | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Card Footer -->
                        <div class="card-action-footer">
                            <button type="button" 
                                    class="btn-view-template" 
                                    (click)="openModal(content)" 
                                    (click)="preview(data)">
                                <i class="fi-rr-eye mr-1"></i> {{ "Preview Template" | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Admin Templates Section -->
        <div class="template-section mb-5" *ngIf="!loading && (activeTab === 'all' || activeTab === 'admin' || activeTab === 'dealer') && filteredAdminTemplates.length > 0">
            <div class="section-header d-flex align-items-center justify-content-between mb-3">
                <div class="d-flex align-items-center gap-2">
                    <div class="section-icon-badge admin-badge">
                        <i class="fi-rr-shield-check"></i>
                    </div>
                    <div>
                        <h5 class="section-heading mb-0">{{ "Admin Emails" | translate }}</h5>
                        <p class="section-subtext mb-0">{{ "Automated notifications sent to store administrators" | translate }}</p>
                    </div>
                </div>
                <span class="badge badge-light-primary rounded-pill px-3 py-2 font-weight-medium">
                    {{ "{0} Templates" | translate: [filteredAdminTemplates.length] }}
                </span>
            </div>

            <div class="email-grid">
                <div class="email-card admin-card" *ngFor="let data of filteredAdminTemplates">
                    <div class="card-inner">
                        <!-- Top Tag Bar -->
                        <div class="card-header-bar">
                            <span class="recipient-tag tag-admin">
                                <i class="fi-rr-shield-check mr-1"></i> {{ "Admin" | translate }}
                            </span>
                            <span class="template-id-tag" *ngIf="data.id || data.template_id">
                                #{{ data.id || data.template_id }}
                            </span>
                        </div>

                        <!-- Card Body -->
                        <div class="card-main">
                            <h6 class="email-title" [title]="data.display_name">{{ data.display_name }}</h6>
                            
                            <!-- Inline Description -->
                            <p class="email-description" [title]="data.description">
                                {{ data.description || ('Automated notification email sent to store administrator.' | translate) }}
                            </p>

                            <!-- Image Frame -->
                            <div class="image-frame" (click)="openModal(content)" (click)="preview(data)">
                                <img [src]="data.image"
                                     onerror="this.onerror=null;this.src='https://cdn.estore5s.com/asset/email-default.png';"
                                     [alt]="data.display_name"
                                     class="preview-img">
                                <div class="image-overlay">
                                    <span class="preview-btn">
                                        <i class="fi-rr-eye mr-1"></i> {{ "Quick View" | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Card Footer -->
                        <div class="card-action-footer">
                            <button type="button" 
                                    class="btn-view-template" 
                                    (click)="openModal(content)" 
                                    (click)="preview(data)">
                                <i class="fi-rr-eye mr-1"></i> {{ "Preview Template" | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<!-- Preview Modal -->
<ng-template #content let-modal>
    <div class="modal-header modern-modal-header border-0 pb-0">
        <div class="d-flex align-items-center gap-2">
            <div class="modal-icon-badge">
                <i class="fi-rr-envelope"></i>
            </div>
            <div>
                <h5 class="modal-title font-weight-bold mb-0" id="modal-basic-title">{{ template_display_name }}</h5>
                <span class="text-muted small">{{ "Template Preview & Description" | translate }}</span>
            </div>
        </div>
        <button type="button" class="modal-close-btn" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <i class="fi-rr-cross"></i>
        </button>
    </div>

    <div class="modal-body modern-modal-body p-4">
        <!-- Description Callout inside Modal -->
        <div class="description-callout mb-4" *ngIf="template_description">
            <div class="d-flex align-items-start gap-2">
                <i class="fi-rr-info callout-icon mt-1"></i>
                <div>
                    <h6 class="callout-heading mb-1">{{ "Email Description & Trigger Purpose" | translate }}</h6>
                    <p class="callout-text mb-0">{{ template_description }}</p>
                </div>
            </div>
        </div>

        <!-- Full Image Wrapper with Scrollable Frame -->
        <div class="email-preview-scroll-container">
            <img class="img-fluid modal-preview-img" 
                 [src]="template_image"
                 onerror="this.onerror=null;this.src='https://cdn.estore5s.com/asset/email-default.png';"
                 [alt]="template_display_name">
        </div>
    </div>

    <div class="modal-footer modern-modal-footer border-0 pt-0">
        <button type="button" class="btn btn-secondary rounded-pill px-4" (click)="modal.dismiss('Close click')">
            {{ "Close Preview" | translate }}
        </button>
    </div>
</ng-template>